import { WorldpayIframeFormValue } from './worldpay-iframe-form-value.interface';
import { WorldpayOptions } from './worldpay-options.interface';

export interface WorldpayInstance {
  destroy: () => void;
  instanceId: number;
  isFakeLoadEvent: boolean;
  isPostMessage: boolean;
  lightboxMaxWidth: number;
  onLoadInject: () => void;
  options: WorldpayOptions;
  populateForm: (formValue: Partial<WorldpayIframeFormValue>) => void;
  postMessageHandler: () => void;
  prefix: string;
  redirect: () => void;
  resize: () => void;
  scroll: () => void;
  sdkInfoAlreadySent: boolean;
  setup: (options: WorldpayOptions) => void;
  submitForm: () => void;
  wpName: string;
}
